import React from "react";
import Footer from "../../../layout/Footer";
import Header from "../../../layout/Header";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../../layout/HeroSection";
import { pageRoutes } from "../../../routes/pageRoutes";

const Pricing = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Header />
      <HeroSection label={<h1 class="mb-3">{"Pricing"}</h1>} />
      <section className="untree_co-section pt-5">
        <div class="container">
          <h2 class="text-center  fw-bold mb-5">Choose Your Plan</h2>

          <div className="row">
            <ul
              class="nav nav-pills mb-3 ct_pricing_tabs ct_pricing_tabs mb-4"
              id="pills-tab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-monthly-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-monthly"
                  type="button"
                  role="tab"
                  aria-controls="pills-monthly"
                  aria-selected="true"
                >
                  Monthly
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-yearly-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-yearly"
                  type="button"
                  role="tab"
                  aria-controls="pills-yearly"
                  aria-selected="false"
                >
                  Yearly
                </button>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-monthly"
                role="tabpanel"
                aria-labelledby="pills-monthly-tab"
              >
                <div class="row">
                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Single User</h4>
                      <p class="text-muted">Perfect for individuals</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $2.99 <span class="fs-6">/month</span>
                      </h3>
                      {/* <p class="text-muted">or $30/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Single Users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Classroom Pass</h4>
                      <p class="text-muted">For up to 35 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $50 <span class="fs-6">/month</span>
                      </h3>
                      {/* <p class="text-muted">or $500/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 35 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Grade-Level Pass</h4>
                      <p class="text-muted">For up to 105 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $100 <span class="fs-6">/month</span>
                      </h3>
                      {/* <p class="text-muted">or $1000/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 105 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">School Pass</h4>
                      <p class="text-muted">For up to 500 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $300 <span class="fs-6">/month</span>
                      </h3>
                      {/* <p class="text-muted">or $3000/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 500 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="pills-yearly"
                role="tabpanel"
                aria-labelledby="pills-yearly-tab"
              >
                <div class="row">
                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Single User</h4>
                      <p class="text-muted">Perfect for individuals</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $30 <span class="fs-6">/year</span>
                      </h3>
                      {/* <p class="text-muted">or $30/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Single User
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Classroom Pass</h4>
                      <p class="text-muted">For up to 35 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $500 <span class="fs-6">/year</span>
                      </h3>
                      {/* <p class="text-muted">or $500/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 35 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">Grade-Level Pass</h4>
                      <p class="text-muted">For up to 105 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $1000 <span class="fs-6">/year</span>
                      </h3>
                      {/* <p class="text-muted">or $1000/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 105 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="ct_pricing_card h-100">
                      <h4 class="ct_fs_24 ct_fw_600">School Pass</h4>
                      <p class="text-muted">For up to 500 users</p>
                      <h3 class="fw-bold ct_yellow_clr">
                        $3000 <span class="fs-6">/year</span>
                      </h3>
                      {/* <p class="text-muted">or $3000/year</p> */}
                      <ul class="list-unstyled">
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          For up to 500 users
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                        <li>
                          <i class="fa-solid fa-check me-2 ct_green_text_1"></i>{" "}
                          Lorem ipsum dolor sit amet.
                        </li>
                      </ul>
                      <a
                        href="#"
                        class="btn btn-secondary ct_btn_animate w-100 mt-3"
                        onClick={() => navigate(pageRoutes?.checkoutToPay)}git 
                      >
                        Choose Plan
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Pricing;
